import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Ahora tengo todo mucho más claro. Antes improvisaba un montón en consulta infantil. Hoy entro mucho más segura y con herramientas posta.',
    initials: 'MP',
    name: 'Mariana P.',
    role: 'Nutricionista infantil',
    flag: '🇦🇷',
    country: 'Buenos Aires, Argentina'
  }, {
    quote: 'Las láminas hacen toda la diferencia. Empecé a mostrarle al nene qué comer con imágenes y la comprensión cambió un montón. Las mamás se llevan algo concreto.',
    initials: 'LS',
    name: 'Luciana S.',
    role: 'Consultorio privado',
    flag: '🇦🇷',
    country: 'Córdoba, Argentina'
  }, {
    quote: 'Me ahorra tiempo y cabeza. Ya no me llevo los casos pensando a casa. Tengo estructura, recursos y material listo para entregar a las familias.',
    initials: 'CG',
    name: 'Carla G.',
    role: 'Nutricionista pediátrica',
    flag: '🇦🇷',
    country: 'Rosario, Argentina'
  }];
  return <section className="py-10 md:py-14 px-4 bg-black border-y border-sand/10" data-id="element-215">
      <div className="max-w-6xl mx-auto" data-id="element-216">
        <FadeIn className="text-center mb-16" data-id="element-217">
          <span className="text-sand text-sm font-bold tracking-widest uppercase mb-4 block" data-id="element-218">
            Testimonios verificados
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-cream mb-6" data-id="element-219">
            Lo que dicen las nutricionistas
          </h2>
          <div className="flex items-center justify-center gap-2 text-terracotta mb-2" data-id="element-220">
            {[...Array(5)].map((_, i) => <Star key={i} size={20} className="fill-current" data-id="element-221" />)}
          </div>
          <p className="text-cream/60 font-bold tracking-widest uppercase text-sm" data-id="element-222">
            4.9 · 850+ reseñas
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-223">
          {testimonials.map((t, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-224">
              <div className="glow-beige bg-black rounded-2xl p-8 h-full flex flex-col" data-id="element-225">
                <div className="flex items-center gap-4 mb-6" data-id="element-226">
                  <div className="w-12 h-12 rounded-full bg-terracotta/20 text-terracotta flex items-center justify-center font-display font-bold text-xl" data-id="element-227">
                    {t.initials}
                  </div>
                  <div className="flex gap-1 text-terracotta" data-id="element-228">
                    {[...Array(5)].map((_, i) => <Star key={i} size={14} className="fill-current" data-id="element-229" />)}
                  </div>
                </div>

                <p className="text-cream/80 leading-relaxed italic mb-8 flex-grow" data-id="element-230">
                  "{t.quote}"
                </p>

                <div className="border-t border-sand/10 pt-4" data-id="element-231">
                  <p className="font-bold text-cream mb-1" data-id="element-232">{t.name}</p>
                  <p className="text-sm text-cream/50" data-id="element-233">
                    {t.role} · {t.flag} {t.country}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} className="text-center" data-id="element-234">
          <p className="text-cream/40 text-xs font-bold tracking-widest uppercase" data-id="element-235">
            Reseñas verificadas por compradoras reales
          </p>
        </FadeIn>
      </div>
    </section>;
}